import axios from 'axios'
// {headers: {'content-type': 'application/x-www-form-urlencoded'}
export const instance = axios.create({
  baseURL: globalVars.api
});
export const systemApi = axios.create({
  baseURL: globalVars.systemApi
});
